(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bw-airrove-fr-drag"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bw-drag-scroll')) {
  customElements.define('bw-drag-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.dragController) return;
      this.dragController = new AbortController();
      const options = {signal:this.dragController.signal};
      this.addEventListener('pointerdown', event => this.startDrag(event), options);
      window.addEventListener('pointermove', event => this.moveDrag(event), {...options,passive:false});
      window.addEventListener('pointerup', event => this.endDrag(event), options);
      window.addEventListener('pointercancel', event => this.endDrag(event,true), options);
      window.addEventListener('blur', () => this.endDrag(null,true), options);
      this.addEventListener('lostpointercapture', event => this.endDrag(event,true), options);
      this.addEventListener('dragstart', event => {
        if (this.pointer) event.preventDefault();
      }, options);
      this.addEventListener('click', event => {
        if (this.suppressDragClick && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressDragClick = false;
        }
      }, {...options,capture:true});
      this.dragResize = new ResizeObserver(() => this.toggleAttribute('data-draggable',this.scrollWidth > this.clientWidth + 2));
      this.dragResize.observe(this);
    }
    startDrag(event) {
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.scrollWidth <= this.clientWidth + 2) return;
      if (event.target.closest('input,textarea,select,video,iframe,model-viewer,[data-no-drag]')) return;
      this.scrollTo({left:this.scrollLeft,behavior:'instant'});
      this.pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,left:this.scrollLeft,delta:0,dragged:false,snap:getComputedStyle(this).scrollSnapType !== 'none'};
      this.setAttribute('data-pointer-down','');
    }
    moveDrag(event) {
      const pointer = this.pointer;
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (!pointer.dragged) {
        if (Math.abs(delta) < 6) return;
        if (Math.abs(event.clientY-pointer.y) > Math.abs(delta)) {this.endDrag(event,true);return;}
        pointer.dragged = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      pointer.delta = delta;
      this.scrollLeft = pointer.left - delta;
    }
    snapDestination(pointer,cancelled) {
      const max = Math.max(0,this.scrollWidth-this.clientWidth);
      const rect = this.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this).scrollPaddingLeft) || 0;
      const stops = [...new Set([0,...[...this.children].map(child => Math.max(0,Math.min(max,child.getBoundingClientRect().left-rect.left+this.scrollLeft-padding))),max])].sort((a,b)=>a-b);
      const nearest = value => stops.reduce((best,stop)=>Math.abs(stop-value)<Math.abs(best-value)?stop:best,stops[0]);
      const start = nearest(pointer.left);
      let target = nearest(this.scrollLeft);
      if (!cancelled && Math.abs(target-start)<1) {
        const index = stops.indexOf(start);
        const next = stops[index+(pointer.delta<0?1:-1)];
        if (next !== undefined && Math.abs(pointer.delta)>Math.min(100,Math.abs(next-start)*.2)) target=next;
      }
      return target;
    }
    endDrag(event,cancelled=false) {
      const pointer = this.pointer;
      if (!pointer || (event && event.pointerId !== pointer.id)) return;
      this.pointer = null;
      const target = pointer.dragged && pointer.snap ? this.snapDestination(pointer,cancelled) : null;
      this.classList.remove('is-dragging');
      this.removeAttribute('data-pointer-down');
      if (this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
      if (pointer.dragged) {
        this.suppressDragClick = true;
        this.clickReset = setTimeout(()=>{this.suppressDragClick=false;},400);
        if (target !== null) this.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    disconnectedCallback() {
      this.endDrag(null,true);
      this.dragController?.abort();
      this.dragController = null;
      this.dragResize?.disconnect();
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-esperanza-drag-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bwe-drag-scroll')) {
  customElements.define('bwe-drag-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.dragController) return;
      this.dragController = new AbortController();
      const options = {signal:this.dragController.signal};
      this.addEventListener('pointerdown', event => this.startDrag(event), options);
      window.addEventListener('pointermove', event => this.moveDrag(event), {...options,passive:false});
      window.addEventListener('pointerup', event => this.endDrag(event), options);
      window.addEventListener('pointercancel', event => this.endDrag(event,true), options);
      window.addEventListener('blur', () => this.endDrag(null,true), options);
      this.addEventListener('lostpointercapture', event => this.endDrag(event,true), options);
      this.addEventListener('dragstart', event => {
        if (this.pointer) event.preventDefault();
      }, options);
      this.addEventListener('click', event => {
        if (this.suppressDragClick && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressDragClick = false;
        }
      }, {...options,capture:true});
      this.dragResize = new ResizeObserver(() => this.toggleAttribute('data-draggable',this.scrollWidth > this.clientWidth + 2));
      this.dragResize.observe(this);
    }
    startDrag(event) {
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.scrollWidth <= this.clientWidth + 2) return;
      if (event.target.closest('input,textarea,select,video,iframe,model-viewer,[data-no-drag]')) return;
      this.scrollTo({left:this.scrollLeft,behavior:'instant'});
      this.pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,left:this.scrollLeft,delta:0,dragged:false,snap:getComputedStyle(this).scrollSnapType !== 'none'};
      this.setAttribute('data-pointer-down','');
    }
    moveDrag(event) {
      const pointer = this.pointer;
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (!pointer.dragged) {
        if (Math.abs(delta) < 6) return;
        if (Math.abs(event.clientY-pointer.y) > Math.abs(delta)) {this.endDrag(event,true);return;}
        pointer.dragged = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      pointer.delta = delta;
      this.scrollLeft = pointer.left - delta;
    }
    snapDestination(pointer,cancelled) {
      const max = Math.max(0,this.scrollWidth-this.clientWidth);
      const rect = this.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this).scrollPaddingLeft) || 0;
      const stops = [...new Set([0,...[...this.children].map(child => Math.max(0,Math.min(max,child.getBoundingClientRect().left-rect.left+this.scrollLeft-padding))),max])].sort((a,b)=>a-b);
      const nearest = value => stops.reduce((best,stop)=>Math.abs(stop-value)<Math.abs(best-value)?stop:best,stops[0]);
      const start = nearest(pointer.left);
      let target = nearest(this.scrollLeft);
      if (!cancelled && Math.abs(target-start)<1) {
        const index = stops.indexOf(start);
        const next = stops[index+(pointer.delta<0?1:-1)];
        if (next !== undefined && Math.abs(pointer.delta)>Math.min(100,Math.abs(next-start)*.2)) target=next;
      }
      return target;
    }
    endDrag(event,cancelled=false) {
      const pointer = this.pointer;
      if (!pointer || (event && event.pointerId !== pointer.id)) return;
      this.pointer = null;
      const target = pointer.dragged && pointer.snap ? this.snapDestination(pointer,cancelled) : null;
      this.classList.remove('is-dragging');
      this.removeAttribute('data-pointer-down');
      if (this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
      if (pointer.dragged) {
        this.suppressDragClick = true;
        this.clickReset = setTimeout(()=>{this.suppressDragClick=false;},400);
        if (target !== null) this.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    disconnectedCallback() {
      this.endDrag(null,true);
      this.dragController?.abort();
      this.dragController = null;
      this.dragResize?.disconnect();
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-factory-drag-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bw-drag-scroll')) {
  customElements.define('bw-drag-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.dragController) return;
      this.dragController = new AbortController();
      const options = {signal:this.dragController.signal};
      this.addEventListener('pointerdown', event => this.startDrag(event), options);
      window.addEventListener('pointermove', event => this.moveDrag(event), {...options,passive:false});
      window.addEventListener('pointerup', event => this.endDrag(event), options);
      window.addEventListener('pointercancel', event => this.endDrag(event,true), options);
      window.addEventListener('blur', () => this.endDrag(null,true), options);
      this.addEventListener('lostpointercapture', event => this.endDrag(event,true), options);
      this.addEventListener('dragstart', event => {
        if (this.pointer) event.preventDefault();
      }, options);
      this.addEventListener('click', event => {
        if (this.suppressDragClick && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressDragClick = false;
        }
      }, {...options,capture:true});
      this.dragResize = new ResizeObserver(() => this.toggleAttribute('data-draggable',this.scrollWidth > this.clientWidth + 2));
      this.dragResize.observe(this);
    }
    startDrag(event) {
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.scrollWidth <= this.clientWidth + 2) return;
      if (event.target.closest('input,textarea,select,video,iframe,model-viewer,[data-no-drag]')) return;
      this.scrollTo({left:this.scrollLeft,behavior:'instant'});
      this.pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,left:this.scrollLeft,delta:0,dragged:false,snap:getComputedStyle(this).scrollSnapType !== 'none'};
      this.setAttribute('data-pointer-down','');
    }
    moveDrag(event) {
      const pointer = this.pointer;
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (!pointer.dragged) {
        if (Math.abs(delta) < 6) return;
        if (Math.abs(event.clientY-pointer.y) > Math.abs(delta)) {this.endDrag(event,true);return;}
        pointer.dragged = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      pointer.delta = delta;
      this.scrollLeft = pointer.left - delta;
    }
    snapDestination(pointer,cancelled) {
      const max = Math.max(0,this.scrollWidth-this.clientWidth);
      const rect = this.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this).scrollPaddingLeft) || 0;
      const stops = [...new Set([0,...[...this.children].map(child => Math.max(0,Math.min(max,child.getBoundingClientRect().left-rect.left+this.scrollLeft-padding))),max])].sort((a,b)=>a-b);
      const nearest = value => stops.reduce((best,stop)=>Math.abs(stop-value)<Math.abs(best-value)?stop:best,stops[0]);
      const start = nearest(pointer.left);
      let target = nearest(this.scrollLeft);
      if (!cancelled && Math.abs(target-start)<1) {
        const index = stops.indexOf(start);
        const next = stops[index+(pointer.delta<0?1:-1)];
        if (next !== undefined && Math.abs(pointer.delta)>Math.min(100,Math.abs(next-start)*.2)) target=next;
      }
      return target;
    }
    endDrag(event,cancelled=false) {
      const pointer = this.pointer;
      if (!pointer || (event && event.pointerId !== pointer.id)) return;
      this.pointer = null;
      const target = pointer.dragged && pointer.snap ? this.snapDestination(pointer,cancelled) : null;
      this.classList.remove('is-dragging');
      this.removeAttribute('data-pointer-down');
      if (this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
      if (pointer.dragged) {
        this.suppressDragClick = true;
        this.clickReset = setTimeout(()=>{this.suppressDragClick=false;},400);
        if (target !== null) this.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    disconnectedCallback() {
      this.endDrag(null,true);
      this.dragController?.abort();
      this.dragController = null;
      this.dragResize?.disconnect();
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-fadenglatt-drag-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bwg-drag-scroll')) {
  customElements.define('bwg-drag-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.dragController) return;
      this.dragController = new AbortController();
      const options = {signal:this.dragController.signal};
      this.addEventListener('pointerdown', event => this.startDrag(event), options);
      window.addEventListener('pointermove', event => this.moveDrag(event), {...options,passive:false});
      window.addEventListener('pointerup', event => this.endDrag(event), options);
      window.addEventListener('pointercancel', event => this.endDrag(event,true), options);
      window.addEventListener('blur', () => this.endDrag(null,true), options);
      this.addEventListener('lostpointercapture', event => this.endDrag(event,true), options);
      this.addEventListener('dragstart', event => {
        if (this.pointer) event.preventDefault();
      }, options);
      this.addEventListener('click', event => {
        if (this.suppressDragClick && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressDragClick = false;
        }
      }, {...options,capture:true});
      this.dragResize = new ResizeObserver(() => this.toggleAttribute('data-draggable',this.scrollWidth > this.clientWidth + 2));
      this.dragResize.observe(this);
    }
    startDrag(event) {
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.scrollWidth <= this.clientWidth + 2) return;
      if (event.target.closest('input,textarea,select,video,iframe,model-viewer,[data-no-drag]')) return;
      this.scrollTo({left:this.scrollLeft,behavior:'instant'});
      this.pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,left:this.scrollLeft,delta:0,dragged:false,snap:getComputedStyle(this).scrollSnapType !== 'none'};
      this.setAttribute('data-pointer-down','');
    }
    moveDrag(event) {
      const pointer = this.pointer;
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (!pointer.dragged) {
        if (Math.abs(delta) < 6) return;
        if (Math.abs(event.clientY-pointer.y) > Math.abs(delta)) {this.endDrag(event,true);return;}
        pointer.dragged = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      pointer.delta = delta;
      this.scrollLeft = pointer.left - delta;
    }
    snapDestination(pointer,cancelled) {
      const max = Math.max(0,this.scrollWidth-this.clientWidth);
      const rect = this.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this).scrollPaddingLeft) || 0;
      const stops = [...new Set([0,...[...this.children].map(child => Math.max(0,Math.min(max,child.getBoundingClientRect().left-rect.left+this.scrollLeft-padding))),max])].sort((a,b)=>a-b);
      const nearest = value => stops.reduce((best,stop)=>Math.abs(stop-value)<Math.abs(best-value)?stop:best,stops[0]);
      const start = nearest(pointer.left);
      let target = nearest(this.scrollLeft);
      if (!cancelled && Math.abs(target-start)<1) {
        const index = stops.indexOf(start);
        const next = stops[index+(pointer.delta<0?1:-1)];
        if (next !== undefined && Math.abs(pointer.delta)>Math.min(100,Math.abs(next-start)*.2)) target=next;
      }
      return target;
    }
    endDrag(event,cancelled=false) {
      const pointer = this.pointer;
      if (!pointer || (event && event.pointerId !== pointer.id)) return;
      this.pointer = null;
      const target = pointer.dragged && pointer.snap ? this.snapDestination(pointer,cancelled) : null;
      this.classList.remove('is-dragging');
      this.removeAttribute('data-pointer-down');
      if (this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
      if (pointer.dragged) {
        this.suppressDragClick = true;
        this.clickReset = setTimeout(()=>{this.suppressDragClick=false;},400);
        if (target !== null) this.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    disconnectedCallback() {
      this.endDrag(null,true);
      this.dragController?.abort();
      this.dragController = null;
      this.dragResize?.disconnect();
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-fadenglatt-video-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bwg-video')) {
  customElements.define('bwg-video', class extends HTMLElement {
    connectedCallback() {
      if (this.io) return;
      const video = this.querySelector('video'), toggle = this.querySelector('.bwg-video-toggle'), play = this.querySelector('.bwg-video-play');
      const click = this.hasAttribute('data-click');
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.userPaused = false;
      const start = () => { video.preload = 'auto'; video.play().catch(sync); };
      const sync = () => {
        const paused = video.paused;
        toggle.classList.toggle('is-paused', paused);
        toggle.setAttribute('aria-label', paused ? toggle.dataset.play : toggle.dataset.pause);
        if (click) { play.hidden = !paused; toggle.hidden = paused; }
      };
      video.addEventListener('play', sync); video.addEventListener('pause', sync);
      toggle.addEventListener('click', (event) => { event.stopPropagation(); if (video.paused) { this.userPaused = false; start(); } else { this.userPaused = true; video.pause(); } });
      if (click) {
        play.addEventListener('click', (event) => { event.stopPropagation(); start(); });
        video.addEventListener('click', () => { if (!video.paused) video.pause(); else start(); });
      }
      this.io = new IntersectionObserver((entries) => {
        const visible = entries[0].isIntersecting;
        if (visible && !click && !reduce && !this.userPaused) start();
        else if (!visible && !video.paused) video.pause();
      }, { threshold: 0.4 });
      this.io.observe(this);
      sync();
    }
    disconnectedCallback() { this.io?.disconnect(); this.io = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-kaminer-drag-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bwk-drag-scroll')) {
  customElements.define('bwk-drag-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.dragController) return;
      this.dragController = new AbortController();
      const options = {signal:this.dragController.signal};
      this.addEventListener('pointerdown', event => this.startDrag(event), options);
      window.addEventListener('pointermove', event => this.moveDrag(event), {...options,passive:false});
      window.addEventListener('pointerup', event => this.endDrag(event), options);
      window.addEventListener('pointercancel', event => this.endDrag(event,true), options);
      window.addEventListener('blur', () => this.endDrag(null,true), options);
      this.addEventListener('lostpointercapture', event => this.endDrag(event,true), options);
      this.addEventListener('dragstart', event => {
        if (this.pointer) event.preventDefault();
      }, options);
      this.addEventListener('click', event => {
        if (this.suppressDragClick && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressDragClick = false;
        }
      }, {...options,capture:true});
      this.dragResize = new ResizeObserver(() => this.toggleAttribute('data-draggable',this.scrollWidth > this.clientWidth + 2));
      this.dragResize.observe(this);
    }
    startDrag(event) {
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.scrollWidth <= this.clientWidth + 2) return;
      if (event.target.closest('input,textarea,select,video,iframe,model-viewer,[data-no-drag]')) return;
      this.scrollTo({left:this.scrollLeft,behavior:'instant'});
      this.pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,left:this.scrollLeft,delta:0,dragged:false,snap:getComputedStyle(this).scrollSnapType !== 'none'};
      this.setAttribute('data-pointer-down','');
    }
    moveDrag(event) {
      const pointer = this.pointer;
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (!pointer.dragged) {
        if (Math.abs(delta) < 6) return;
        if (Math.abs(event.clientY-pointer.y) > Math.abs(delta)) {this.endDrag(event,true);return;}
        pointer.dragged = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      pointer.delta = delta;
      this.scrollLeft = pointer.left - delta;
    }
    snapDestination(pointer,cancelled) {
      const max = Math.max(0,this.scrollWidth-this.clientWidth);
      const rect = this.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this).scrollPaddingLeft) || 0;
      const stops = [...new Set([0,...[...this.children].map(child => Math.max(0,Math.min(max,child.getBoundingClientRect().left-rect.left+this.scrollLeft-padding))),max])].sort((a,b)=>a-b);
      const nearest = value => stops.reduce((best,stop)=>Math.abs(stop-value)<Math.abs(best-value)?stop:best,stops[0]);
      const start = nearest(pointer.left);
      let target = nearest(this.scrollLeft);
      if (!cancelled && Math.abs(target-start)<1) {
        const index = stops.indexOf(start);
        const next = stops[index+(pointer.delta<0?1:-1)];
        if (next !== undefined && Math.abs(pointer.delta)>Math.min(100,Math.abs(next-start)*.2)) target=next;
      }
      return target;
    }
    endDrag(event,cancelled=false) {
      const pointer = this.pointer;
      if (!pointer || (event && event.pointerId !== pointer.id)) return;
      this.pointer = null;
      const target = pointer.dragged && pointer.snap ? this.snapDestination(pointer,cancelled) : null;
      this.classList.remove('is-dragging');
      this.removeAttribute('data-pointer-down');
      if (this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
      if (pointer.dragged) {
        this.suppressDragClick = true;
        this.clickReset = setTimeout(()=>{this.suppressDragClick=false;},400);
        if (target !== null) this.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    disconnectedCallback() {
      this.endDrag(null,true);
      this.dragController?.abort();
      this.dragController = null;
      this.dragResize?.disconnect();
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-lumbava-drag-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bwd-drag-scroll')) {
  customElements.define('bwd-drag-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.dragController) return;
      this.dragController = new AbortController();
      const options = {signal:this.dragController.signal};
      this.addEventListener('pointerdown', event => this.startDrag(event), options);
      window.addEventListener('pointermove', event => this.moveDrag(event), {...options,passive:false});
      window.addEventListener('pointerup', event => this.endDrag(event), options);
      window.addEventListener('pointercancel', event => this.endDrag(event,true), options);
      window.addEventListener('blur', () => this.endDrag(null,true), options);
      this.addEventListener('lostpointercapture', event => this.endDrag(event,true), options);
      this.addEventListener('dragstart', event => {
        if (this.pointer) event.preventDefault();
      }, options);
      this.addEventListener('click', event => {
        if (this.suppressDragClick && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressDragClick = false;
        }
      }, {...options,capture:true});
      this.dragResize = new ResizeObserver(() => this.toggleAttribute('data-draggable',this.scrollWidth > this.clientWidth + 2));
      this.dragResize.observe(this);
    }
    startDrag(event) {
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.scrollWidth <= this.clientWidth + 2) return;
      if (event.target.closest('input,textarea,select,video,iframe,model-viewer,[data-no-drag]')) return;
      this.scrollTo({left:this.scrollLeft,behavior:'instant'});
      this.pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,left:this.scrollLeft,delta:0,dragged:false,snap:getComputedStyle(this).scrollSnapType !== 'none'};
      this.setAttribute('data-pointer-down','');
    }
    moveDrag(event) {
      const pointer = this.pointer;
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (!pointer.dragged) {
        if (Math.abs(delta) < 6) return;
        if (Math.abs(event.clientY-pointer.y) > Math.abs(delta)) {this.endDrag(event,true);return;}
        pointer.dragged = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      pointer.delta = delta;
      this.scrollLeft = pointer.left - delta;
    }
    snapDestination(pointer,cancelled) {
      const max = Math.max(0,this.scrollWidth-this.clientWidth);
      const rect = this.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this).scrollPaddingLeft) || 0;
      const stops = [...new Set([0,...[...this.children].map(child => Math.max(0,Math.min(max,child.getBoundingClientRect().left-rect.left+this.scrollLeft-padding))),max])].sort((a,b)=>a-b);
      const nearest = value => stops.reduce((best,stop)=>Math.abs(stop-value)<Math.abs(best-value)?stop:best,stops[0]);
      const start = nearest(pointer.left);
      let target = nearest(this.scrollLeft);
      if (!cancelled && Math.abs(target-start)<1) {
        const index = stops.indexOf(start);
        const next = stops[index+(pointer.delta<0?1:-1)];
        if (next !== undefined && Math.abs(pointer.delta)>Math.min(100,Math.abs(next-start)*.2)) target=next;
      }
      return target;
    }
    endDrag(event,cancelled=false) {
      const pointer = this.pointer;
      if (!pointer || (event && event.pointerId !== pointer.id)) return;
      this.pointer = null;
      const target = pointer.dragged && pointer.snap ? this.snapDestination(pointer,cancelled) : null;
      this.classList.remove('is-dragging');
      this.removeAttribute('data-pointer-down');
      if (this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
      if (pointer.dragged) {
        this.suppressDragClick = true;
        this.clickReset = setTimeout(()=>{this.suppressDragClick=false;},400);
        if (target !== null) this.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    disconnectedCallback() {
      this.endDrag(null,true);
      this.dragController?.abort();
      this.dragController = null;
      this.dragResize?.disconnect();
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-nordidry-drag-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bwd-drag-scroll')) {
  customElements.define('bwd-drag-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.dragController) return;
      this.dragController = new AbortController();
      const options = {signal:this.dragController.signal};
      this.addEventListener('pointerdown', event => this.startDrag(event), options);
      window.addEventListener('pointermove', event => this.moveDrag(event), {...options,passive:false});
      window.addEventListener('pointerup', event => this.endDrag(event), options);
      window.addEventListener('pointercancel', event => this.endDrag(event,true), options);
      window.addEventListener('blur', () => this.endDrag(null,true), options);
      this.addEventListener('lostpointercapture', event => this.endDrag(event,true), options);
      this.addEventListener('dragstart', event => {
        if (this.pointer) event.preventDefault();
      }, options);
      this.addEventListener('click', event => {
        if (this.suppressDragClick && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressDragClick = false;
        }
      }, {...options,capture:true});
      this.dragResize = new ResizeObserver(() => this.toggleAttribute('data-draggable',this.scrollWidth > this.clientWidth + 2));
      this.dragResize.observe(this);
    }
    startDrag(event) {
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.scrollWidth <= this.clientWidth + 2) return;
      if (event.target.closest('input,textarea,select,video,iframe,model-viewer,[data-no-drag]')) return;
      this.scrollTo({left:this.scrollLeft,behavior:'instant'});
      this.pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,left:this.scrollLeft,delta:0,dragged:false,snap:getComputedStyle(this).scrollSnapType !== 'none'};
      this.setAttribute('data-pointer-down','');
    }
    moveDrag(event) {
      const pointer = this.pointer;
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (!pointer.dragged) {
        if (Math.abs(delta) < 6) return;
        if (Math.abs(event.clientY-pointer.y) > Math.abs(delta)) {this.endDrag(event,true);return;}
        pointer.dragged = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      pointer.delta = delta;
      this.scrollLeft = pointer.left - delta;
    }
    snapDestination(pointer,cancelled) {
      const max = Math.max(0,this.scrollWidth-this.clientWidth);
      const rect = this.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this).scrollPaddingLeft) || 0;
      const stops = [...new Set([0,...[...this.children].map(child => Math.max(0,Math.min(max,child.getBoundingClientRect().left-rect.left+this.scrollLeft-padding))),max])].sort((a,b)=>a-b);
      const nearest = value => stops.reduce((best,stop)=>Math.abs(stop-value)<Math.abs(best-value)?stop:best,stops[0]);
      const start = nearest(pointer.left);
      let target = nearest(this.scrollLeft);
      if (!cancelled && Math.abs(target-start)<1) {
        const index = stops.indexOf(start);
        const next = stops[index+(pointer.delta<0?1:-1)];
        if (next !== undefined && Math.abs(pointer.delta)>Math.min(100,Math.abs(next-start)*.2)) target=next;
      }
      return target;
    }
    endDrag(event,cancelled=false) {
      const pointer = this.pointer;
      if (!pointer || (event && event.pointerId !== pointer.id)) return;
      this.pointer = null;
      const target = pointer.dragged && pointer.snap ? this.snapDestination(pointer,cancelled) : null;
      this.classList.remove('is-dragging');
      this.removeAttribute('data-pointer-down');
      if (this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
      if (pointer.dragged) {
        this.suppressDragClick = true;
        this.clickReset = setTimeout(()=>{this.suppressDragClick=false;},400);
        if (target !== null) this.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    disconnectedCallback() {
      this.endDrag(null,true);
      this.dragController?.abort();
      this.dragController = null;
      this.dragResize?.disconnect();
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-nordifell-drag-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bwd-drag-scroll')) {
  customElements.define('bwd-drag-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.dragController) return;
      this.dragController = new AbortController();
      const options = {signal:this.dragController.signal};
      this.addEventListener('pointerdown', event => this.startDrag(event), options);
      window.addEventListener('pointermove', event => this.moveDrag(event), {...options,passive:false});
      window.addEventListener('pointerup', event => this.endDrag(event), options);
      window.addEventListener('pointercancel', event => this.endDrag(event,true), options);
      window.addEventListener('blur', () => this.endDrag(null,true), options);
      this.addEventListener('lostpointercapture', event => this.endDrag(event,true), options);
      this.addEventListener('dragstart', event => {
        if (this.pointer) event.preventDefault();
      }, options);
      this.addEventListener('click', event => {
        if (this.suppressDragClick && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressDragClick = false;
        }
      }, {...options,capture:true});
      this.dragResize = new ResizeObserver(() => this.toggleAttribute('data-draggable',this.scrollWidth > this.clientWidth + 2));
      this.dragResize.observe(this);
    }
    startDrag(event) {
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.scrollWidth <= this.clientWidth + 2) return;
      if (event.target.closest('input,textarea,select,video,iframe,model-viewer,[data-no-drag]')) return;
      this.scrollTo({left:this.scrollLeft,behavior:'instant'});
      this.pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,left:this.scrollLeft,delta:0,dragged:false,snap:getComputedStyle(this).scrollSnapType !== 'none'};
      this.setAttribute('data-pointer-down','');
    }
    moveDrag(event) {
      const pointer = this.pointer;
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (!pointer.dragged) {
        if (Math.abs(delta) < 6) return;
        if (Math.abs(event.clientY-pointer.y) > Math.abs(delta)) {this.endDrag(event,true);return;}
        pointer.dragged = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      pointer.delta = delta;
      this.scrollLeft = pointer.left - delta;
    }
    snapDestination(pointer,cancelled) {
      const max = Math.max(0,this.scrollWidth-this.clientWidth);
      const rect = this.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this).scrollPaddingLeft) || 0;
      const stops = [...new Set([0,...[...this.children].map(child => Math.max(0,Math.min(max,child.getBoundingClientRect().left-rect.left+this.scrollLeft-padding))),max])].sort((a,b)=>a-b);
      const nearest = value => stops.reduce((best,stop)=>Math.abs(stop-value)<Math.abs(best-value)?stop:best,stops[0]);
      const start = nearest(pointer.left);
      let target = nearest(this.scrollLeft);
      if (!cancelled && Math.abs(target-start)<1) {
        const index = stops.indexOf(start);
        const next = stops[index+(pointer.delta<0?1:-1)];
        if (next !== undefined && Math.abs(pointer.delta)>Math.min(100,Math.abs(next-start)*.2)) target=next;
      }
      return target;
    }
    endDrag(event,cancelled=false) {
      const pointer = this.pointer;
      if (!pointer || (event && event.pointerId !== pointer.id)) return;
      this.pointer = null;
      const target = pointer.dragged && pointer.snap ? this.snapDestination(pointer,cancelled) : null;
      this.classList.remove('is-dragging');
      this.removeAttribute('data-pointer-down');
      if (this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
      if (pointer.dragged) {
        this.suppressDragClick = true;
        this.clickReset = setTimeout(()=>{this.suppressDragClick=false;},400);
        if (target !== null) this.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    disconnectedCallback() {
      this.endDrag(null,true);
      this.dragController?.abort();
      this.dragController = null;
      this.dragResize?.disconnect();
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-nordiwake-drag-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bwd-drag-scroll')) {
  customElements.define('bwd-drag-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.dragController) return;
      this.dragController = new AbortController();
      const options = {signal:this.dragController.signal};
      this.addEventListener('pointerdown', event => this.startDrag(event), options);
      window.addEventListener('pointermove', event => this.moveDrag(event), {...options,passive:false});
      window.addEventListener('pointerup', event => this.endDrag(event), options);
      window.addEventListener('pointercancel', event => this.endDrag(event,true), options);
      window.addEventListener('blur', () => this.endDrag(null,true), options);
      this.addEventListener('lostpointercapture', event => this.endDrag(event,true), options);
      this.addEventListener('dragstart', event => {
        if (this.pointer) event.preventDefault();
      }, options);
      this.addEventListener('click', event => {
        if (this.suppressDragClick && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressDragClick = false;
        }
      }, {...options,capture:true});
      this.dragResize = new ResizeObserver(() => this.toggleAttribute('data-draggable',this.scrollWidth > this.clientWidth + 2));
      this.dragResize.observe(this);
    }
    startDrag(event) {
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.scrollWidth <= this.clientWidth + 2) return;
      if (event.target.closest('input,textarea,select,video,iframe,model-viewer,[data-no-drag]')) return;
      this.scrollTo({left:this.scrollLeft,behavior:'instant'});
      this.pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,left:this.scrollLeft,delta:0,dragged:false,snap:getComputedStyle(this).scrollSnapType !== 'none'};
      this.setAttribute('data-pointer-down','');
    }
    moveDrag(event) {
      const pointer = this.pointer;
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (!pointer.dragged) {
        if (Math.abs(delta) < 6) return;
        if (Math.abs(event.clientY-pointer.y) > Math.abs(delta)) {this.endDrag(event,true);return;}
        pointer.dragged = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      pointer.delta = delta;
      this.scrollLeft = pointer.left - delta;
    }
    snapDestination(pointer,cancelled) {
      const max = Math.max(0,this.scrollWidth-this.clientWidth);
      const rect = this.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this).scrollPaddingLeft) || 0;
      const stops = [...new Set([0,...[...this.children].map(child => Math.max(0,Math.min(max,child.getBoundingClientRect().left-rect.left+this.scrollLeft-padding))),max])].sort((a,b)=>a-b);
      const nearest = value => stops.reduce((best,stop)=>Math.abs(stop-value)<Math.abs(best-value)?stop:best,stops[0]);
      const start = nearest(pointer.left);
      let target = nearest(this.scrollLeft);
      if (!cancelled && Math.abs(target-start)<1) {
        const index = stops.indexOf(start);
        const next = stops[index+(pointer.delta<0?1:-1)];
        if (next !== undefined && Math.abs(pointer.delta)>Math.min(100,Math.abs(next-start)*.2)) target=next;
      }
      return target;
    }
    endDrag(event,cancelled=false) {
      const pointer = this.pointer;
      if (!pointer || (event && event.pointerId !== pointer.id)) return;
      this.pointer = null;
      const target = pointer.dragged && pointer.snap ? this.snapDestination(pointer,cancelled) : null;
      this.classList.remove('is-dragging');
      this.removeAttribute('data-pointer-down');
      if (this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
      if (pointer.dragged) {
        this.suppressDragClick = true;
        this.clickReset = setTimeout(()=>{this.suppressDragClick=false;},400);
        if (target !== null) this.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    disconnectedCallback() {
      this.endDrag(null,true);
      this.dragController?.abort();
      this.dragController = null;
      this.dragResize?.disconnect();
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-orthonexo-drag-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bwd-drag-scroll')) {
  customElements.define('bwd-drag-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.dragController) return;
      this.dragController = new AbortController();
      const options = {signal:this.dragController.signal};
      this.addEventListener('pointerdown', event => this.startDrag(event), options);
      window.addEventListener('pointermove', event => this.moveDrag(event), {...options,passive:false});
      window.addEventListener('pointerup', event => this.endDrag(event), options);
      window.addEventListener('pointercancel', event => this.endDrag(event,true), options);
      window.addEventListener('blur', () => this.endDrag(null,true), options);
      this.addEventListener('lostpointercapture', event => this.endDrag(event,true), options);
      this.addEventListener('dragstart', event => {
        if (this.pointer) event.preventDefault();
      }, options);
      this.addEventListener('click', event => {
        if (this.suppressDragClick && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressDragClick = false;
        }
      }, {...options,capture:true});
      this.dragResize = new ResizeObserver(() => this.toggleAttribute('data-draggable',this.scrollWidth > this.clientWidth + 2));
      this.dragResize.observe(this);
    }
    startDrag(event) {
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.scrollWidth <= this.clientWidth + 2) return;
      if (event.target.closest('input,textarea,select,video,iframe,model-viewer,[data-no-drag]')) return;
      this.scrollTo({left:this.scrollLeft,behavior:'instant'});
      this.pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,left:this.scrollLeft,delta:0,dragged:false,snap:getComputedStyle(this).scrollSnapType !== 'none'};
      this.setAttribute('data-pointer-down','');
    }
    moveDrag(event) {
      const pointer = this.pointer;
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (!pointer.dragged) {
        if (Math.abs(delta) < 6) return;
        if (Math.abs(event.clientY-pointer.y) > Math.abs(delta)) {this.endDrag(event,true);return;}
        pointer.dragged = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      pointer.delta = delta;
      this.scrollLeft = pointer.left - delta;
    }
    snapDestination(pointer,cancelled) {
      const max = Math.max(0,this.scrollWidth-this.clientWidth);
      const rect = this.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this).scrollPaddingLeft) || 0;
      const stops = [...new Set([0,...[...this.children].map(child => Math.max(0,Math.min(max,child.getBoundingClientRect().left-rect.left+this.scrollLeft-padding))),max])].sort((a,b)=>a-b);
      const nearest = value => stops.reduce((best,stop)=>Math.abs(stop-value)<Math.abs(best-value)?stop:best,stops[0]);
      const start = nearest(pointer.left);
      let target = nearest(this.scrollLeft);
      if (!cancelled && Math.abs(target-start)<1) {
        const index = stops.indexOf(start);
        const next = stops[index+(pointer.delta<0?1:-1)];
        if (next !== undefined && Math.abs(pointer.delta)>Math.min(100,Math.abs(next-start)*.2)) target=next;
      }
      return target;
    }
    endDrag(event,cancelled=false) {
      const pointer = this.pointer;
      if (!pointer || (event && event.pointerId !== pointer.id)) return;
      this.pointer = null;
      const target = pointer.dragged && pointer.snap ? this.snapDestination(pointer,cancelled) : null;
      this.classList.remove('is-dragging');
      this.removeAttribute('data-pointer-down');
      if (this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
      if (pointer.dragged) {
        this.suppressDragClick = true;
        this.clickReset = setTimeout(()=>{this.suppressDragClick=false;},400);
        if (target !== null) this.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    disconnectedCallback() {
      this.endDrag(null,true);
      this.dragController?.abort();
      this.dragController = null;
      this.dragResize?.disconnect();
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-scrivora-drag-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bws-drag-scroll')) {
  customElements.define('bws-drag-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.dragController) return;
      this.dragController = new AbortController();
      const options = {signal:this.dragController.signal};
      this.addEventListener('pointerdown', event => this.startDrag(event), options);
      window.addEventListener('pointermove', event => this.moveDrag(event), {...options,passive:false});
      window.addEventListener('pointerup', event => this.endDrag(event), options);
      window.addEventListener('pointercancel', event => this.endDrag(event,true), options);
      window.addEventListener('blur', () => this.endDrag(null,true), options);
      this.addEventListener('lostpointercapture', event => this.endDrag(event,true), options);
      this.addEventListener('dragstart', event => {
        if (this.pointer) event.preventDefault();
      }, options);
      this.addEventListener('click', event => {
        if (this.suppressDragClick && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressDragClick = false;
        }
      }, {...options,capture:true});
      this.dragResize = new ResizeObserver(() => this.toggleAttribute('data-draggable',this.scrollWidth > this.clientWidth + 2));
      this.dragResize.observe(this);
    }
    startDrag(event) {
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.scrollWidth <= this.clientWidth + 2) return;
      if (event.target.closest('input,textarea,select,video,iframe,model-viewer,[data-no-drag]')) return;
      this.scrollTo({left:this.scrollLeft,behavior:'instant'});
      this.pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,left:this.scrollLeft,delta:0,dragged:false,snap:getComputedStyle(this).scrollSnapType !== 'none'};
      this.setAttribute('data-pointer-down','');
    }
    moveDrag(event) {
      const pointer = this.pointer;
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (!pointer.dragged) {
        if (Math.abs(delta) < 6) return;
        if (Math.abs(event.clientY-pointer.y) > Math.abs(delta)) {this.endDrag(event,true);return;}
        pointer.dragged = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      pointer.delta = delta;
      this.scrollLeft = pointer.left - delta;
    }
    snapDestination(pointer,cancelled) {
      const max = Math.max(0,this.scrollWidth-this.clientWidth);
      const rect = this.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this).scrollPaddingLeft) || 0;
      const stops = [...new Set([0,...[...this.children].map(child => Math.max(0,Math.min(max,child.getBoundingClientRect().left-rect.left+this.scrollLeft-padding))),max])].sort((a,b)=>a-b);
      const nearest = value => stops.reduce((best,stop)=>Math.abs(stop-value)<Math.abs(best-value)?stop:best,stops[0]);
      const start = nearest(pointer.left);
      let target = nearest(this.scrollLeft);
      if (!cancelled && Math.abs(target-start)<1) {
        const index = stops.indexOf(start);
        const next = stops[index+(pointer.delta<0?1:-1)];
        if (next !== undefined && Math.abs(pointer.delta)>Math.min(100,Math.abs(next-start)*.2)) target=next;
      }
      return target;
    }
    endDrag(event,cancelled=false) {
      const pointer = this.pointer;
      if (!pointer || (event && event.pointerId !== pointer.id)) return;
      this.pointer = null;
      const target = pointer.dragged && pointer.snap ? this.snapDestination(pointer,cancelled) : null;
      this.classList.remove('is-dragging');
      this.removeAttribute('data-pointer-down');
      if (this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
      if (pointer.dragged) {
        this.suppressDragClick = true;
        this.clickReset = setTimeout(()=>{this.suppressDragClick=false;},400);
        if (target !== null) this.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    disconnectedCallback() {
      this.endDrag(null,true);
      this.dragController?.abort();
      this.dragController = null;
      this.dragResize?.disconnect();
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-vilico-drag-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bwv-drag-scroll')) {
  customElements.define('bwv-drag-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.dragController) return;
      this.dragController = new AbortController();
      const options = {signal:this.dragController.signal};
      this.addEventListener('pointerdown', event => this.startDrag(event), options);
      window.addEventListener('pointermove', event => this.moveDrag(event), {...options,passive:false});
      window.addEventListener('pointerup', event => this.endDrag(event), options);
      window.addEventListener('pointercancel', event => this.endDrag(event,true), options);
      window.addEventListener('blur', () => this.endDrag(null,true), options);
      this.addEventListener('lostpointercapture', event => this.endDrag(event,true), options);
      this.addEventListener('dragstart', event => {
        if (this.pointer) event.preventDefault();
      }, options);
      this.addEventListener('click', event => {
        if (this.suppressDragClick && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressDragClick = false;
        }
      }, {...options,capture:true});
      this.dragResize = new ResizeObserver(() => this.toggleAttribute('data-draggable',this.scrollWidth > this.clientWidth + 2));
      this.dragResize.observe(this);
    }
    startDrag(event) {
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.scrollWidth <= this.clientWidth + 2) return;
      if (event.target.closest('input,textarea,select,video,iframe,model-viewer,[data-no-drag]')) return;
      this.scrollTo({left:this.scrollLeft,behavior:'instant'});
      this.pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,left:this.scrollLeft,delta:0,dragged:false,snap:getComputedStyle(this).scrollSnapType !== 'none'};
      this.setAttribute('data-pointer-down','');
    }
    moveDrag(event) {
      const pointer = this.pointer;
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (!pointer.dragged) {
        if (Math.abs(delta) < 6) return;
        if (Math.abs(event.clientY-pointer.y) > Math.abs(delta)) {this.endDrag(event,true);return;}
        pointer.dragged = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      pointer.delta = delta;
      this.scrollLeft = pointer.left - delta;
    }
    snapDestination(pointer,cancelled) {
      const max = Math.max(0,this.scrollWidth-this.clientWidth);
      const rect = this.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this).scrollPaddingLeft) || 0;
      const stops = [...new Set([0,...[...this.children].map(child => Math.max(0,Math.min(max,child.getBoundingClientRect().left-rect.left+this.scrollLeft-padding))),max])].sort((a,b)=>a-b);
      const nearest = value => stops.reduce((best,stop)=>Math.abs(stop-value)<Math.abs(best-value)?stop:best,stops[0]);
      const start = nearest(pointer.left);
      let target = nearest(this.scrollLeft);
      if (!cancelled && Math.abs(target-start)<1) {
        const index = stops.indexOf(start);
        const next = stops[index+(pointer.delta<0?1:-1)];
        if (next !== undefined && Math.abs(pointer.delta)>Math.min(100,Math.abs(next-start)*.2)) target=next;
      }
      return target;
    }
    endDrag(event,cancelled=false) {
      const pointer = this.pointer;
      if (!pointer || (event && event.pointerId !== pointer.id)) return;
      this.pointer = null;
      const target = pointer.dragged && pointer.snap ? this.snapDestination(pointer,cancelled) : null;
      this.classList.remove('is-dragging');
      this.removeAttribute('data-pointer-down');
      if (this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
      if (pointer.dragged) {
        this.suppressDragClick = true;
        this.clickReset = setTimeout(()=>{this.suppressDragClick=false;},400);
        if (target !== null) this.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    disconnectedCallback() {
      this.endDrag(null,true);
      this.dragController?.abort();
      this.dragController = null;
      this.dragResize?.disconnect();
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
